<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-productGroup === ccp -->
      <div class="ccp">
        <div class="ccp-box custom-item" v-if="showList">
          <!-- <div class="ccp-box custom-item"> -->
          <!-- 内容 -->
          <img
            src="@assets/img/template/company-component-coveEn-10-1.jpg"
            width="100%"
            v-if="companyType === 1"
          />
          <img
            src="@assets/img/template/company-component-coveEn-10-2.jpg"
            width="100%"
            v-if="companyType === 2"
          />
          <img
            src="@assets/img/template/company-component-coveEn-10-3.jpg"
            width="100%"
            v-if="companyType === 3"
          />
          <img
            src="@assets/img/template/company-component-coveEn-10-4.jpg"
            width="100%"
            v-if="companyType === 4"
          />
        </div>
        <div class="custom-m-item" v-else>
          <div class="cmi-title">产品分组</div>
          <div class="cmi-brand" style="padding: 40px 15px 0;">
            <div
              class="cmi-brand-item"
              v-for="(item, index) in list"
              :key="'cmi-brand-' + index"
              v-if="index < 3"
            >
              <img :src="item.banner[0]" v-if="item.banner && item.banner[0]" />
              <img src="@assets/img/empty.png" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 产品分组
  name: "custom-company-productGroup",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "产品分组",
          type: 8,
          isOpen: true,
          title: "产品分组",
          groupId: ""
        };
      }
    }
  },
  data() {
    return {
      companyType: 0,
      visible: false,
      model1: [],
      list: [],
      pageSize: 3,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      activeIndex: "customCompanyModule/getActiveIndex"
    }),
    type() {
      return this.Modal.config.type;
    },
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    },
    showList() {
      let bool = false;
      let type = this.companyType;
      if (type === 1 || type === 2 || type === 3 || type === 4) {
        bool = true;
      }
      return bool;
    }
  },
  created() {
    this.getComapyType();
    this.init();
  },
  methods: {
    ...mapActions({
      getProductGroup: "productModule/getProductGroup",
      getProduct: "productModule/getProduct"
    }),
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/proGroup/productadd";
      window.open(link);
    },
    async init() {
      let listData = await this.getProduct(this.option);

      if (listData && listData.items) {
        listData.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
        });
        this.list = listData.items;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    getComapyType() {
      let type = 1;
      const path = this.$route.path;
      if (path.indexOf("service") !== 1) {
        type = 1;
      }
      if (path.indexOf("brand") !== 1) {
        type = 2;
      }
      if (path.indexOf("franchisee") !== 1) {
        type = 3;
      }
      if (path.indexOf("factory") !== 1) {
        type = 4;
      }
      this.companyType = type;
    }
  },
  components: {}
};
</script> 
<style scoped lang="scss">
.ccp {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ccpp {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
.cmi {
  &-group {
    &-item {
    }
  }
}
</style>
